import { createGlobalStyle } from "styled-components";

export const GlobalFluentStyles = createGlobalStyle<{ theme: any }>`
  /* Apply theme colors to Fluent UI components */
  .fui-Input,
  .fui-Dropdown__button,
  .fui-Combobox {
    background-color: ${({ theme }) =>
      theme.semanticColors.inputBackground} !important;
    color: ${({ theme }) => theme.semanticColors.inputText} !important;
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.12)"} !important;
  }

  /* Override Fluent UI's colorNeutralStrokeAccessible for dropdown bottom border */
  .fui-Dropdown,
  .fui-Dropdown__button {
    --colorNeutralStrokeAccessible: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.12)"} !important;
    --colorNeutralStroke1: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.12)"} !important;
    --colorNeutralStroke2: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.12)"} !important;
  }

  .fui-Input:hover:not(:disabled),
  .fui-Dropdown__button:hover:not(:disabled),
  .fui-Combobox:hover:not(:disabled) {
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.18)"} !important;
  }

  .fui-Input:focus,
  .fui-Dropdown__button:focus,
  .fui-Combobox:focus {
    border-color: ${({ theme }) => theme.semanticColors.link} !important;
  }

  .fui-Field__label,
  .fui-Label,
  .fui-Text,
  .fui-Checkbox__label,
  label {
    color: ${({ theme }) => theme.semanticColors.bodyText} !important;
  }

  /* Checkbox border styling */
  .fui-Checkbox__input {
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.12)"} !important;
  }

  .fui-Checkbox__input:hover:not(:disabled) {
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.18)"} !important;
  }

  .fui-Checkbox__input:focus {
    border-color: ${({ theme }) => theme.semanticColors.link} !important;
  }

  .fui-Listbox {
    background-color: ${({ theme }) =>
      theme.semanticColors.menuBackground} !important;
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.12)"} !important;
  }

  .fui-Option {
    background-color: ${({ theme }) =>
      theme.semanticColors.menuBackground} !important;
    color: ${({ theme }) => theme.semanticColors.menuItemText} !important;
    border-bottom: 1px solid ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.05)"
        : "rgba(0, 0, 0, 0.06)"} !important;
  }

  .fui-Option:last-child {
    border-bottom: none !important;
  }

  .fui-Option:hover {
    background-color: ${({ theme }) =>
      theme.semanticColors.menuItemBackgroundHovered} !important;
  }

  .fui-Option[aria-selected="true"] {
    background-color: ${({ theme }) =>
      theme.semanticColors.menuItemBackgroundChecked} !important;
  }

  /* Override native inputs and styled components */
  input:not([type="checkbox"]):not([type="radio"]),
  textarea,
  select {
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.12)"} !important;
  }

  input:not([type="checkbox"]):not([type="radio"]):hover:not(:disabled),
  textarea:hover:not(:disabled),
  select:hover:not(:disabled) {
    border-color: ${({ theme }) =>
      theme.isDark
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.18)"} !important;
  }

  input:not([type="checkbox"]):not([type="radio"]):focus,
  textarea:focus,
  select:focus {
    border-color: ${({ theme }) => theme.semanticColors.link} !important;
  }
`;
